import PropTypes from 'prop-types';
import React from 'react';
import './PageHeader.css';
import TitleComponent from './Title';

const PageHeader = React.memo(({ icon, title, caption, children }) => (
  <header className="pageHeader">
    <TitleComponent icon={icon} title={title} caption={caption} />
    {children && children}
  </header>
));

PageHeader.propTypes = {
  icon: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  caption: PropTypes.string
};

PageHeader.defaultProps = {
  caption: undefined
};

export default PageHeader;
